export default __webpack_public_path__ + "static/media/maintenance_cat_large.eee30bd8.png";